import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useOrder } from "../../contexts/order";
import { OrderType } from "../../enums";

export default function AddOrderModal({ isModalOpen, setIsModalOpen }) {
  const [, { setFormState }] = useOrder();
  function closeModal() {
    setIsModalOpen(false);
  }

  function handleClick(type = 0) {
    setFormState({ type: type, editId: null });
    setIsModalOpen(false);
  }

  return (
    <Transition appear show={isModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Select Order
                </Dialog.Title>

                <div className="mt-3 py-10 border-t border-b">
                  <div className="flex gap-4 justify-between">
                    <button
                      onClick={() => handleClick(OrderType.Barcode)}
                      className="bg-gray-500 text-white p-2 rounded-md"
                    >
                      Barcode
                    </button>
                    <button
                      onClick={() => handleClick(OrderType.Color)}
                      className="bg-gray-500 text-white p-2 rounded-md"
                    >
                      Color
                    </button>
                    <button
                      onClick={() => handleClick(OrderType.Paper)}
                      className="bg-gray-500 text-white p-2 rounded-md"
                    >
                      Paper
                    </button>
                    <button
                      onClick={() => handleClick(OrderType.Sheet)}
                      className="bg-gray-500 text-white p-2 rounded-md"
                    >
                      Sheet
                    </button>
                  </div>
                </div>

                <div className="mt-4 flex justify-end gap-3">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
